if ('serviceWorker' in navigator) {
  /**
   * На проекте может использоваться Pushwoosh, RamblerPush или только offline PWA версия.
   *
   * В обоих случаях: pushwoosh-service-worker.js или import-service-worker.js,
   * в файл подключается PWA версия offline-service-worker.js.
   */
  try {
    const configResolver = require('site/shared-app-config').default;
    const isRamblerPush = configResolver().ramblerPush;

    if (isRamblerPush) {
      navigator.serviceWorker.register('/import-service-worker.js');
    } else {
      /**
       * Для проектов с пушвуш, регистрацией сервис воркера занимается пушвуш.
       * Он регистрирует pushwoosh-service-worker.js.
       *
       * По какой-то причине пушвуш не всегда регистрирует sw или регистрирует
       * его слишком поздно, из-за чего lighthouse не определяет что у нас есть
       * офлайн версия.
       *
       * Чтобы это обойти мы регистрируем свой сервис воркер здесь.
       * Причем, если пушвуш отработает раньше, то мы ничего не делаем,
       * а если позже, то пушвуш перезапишет наш offline-service-worker.js поэтому
       * все должно работать.
       */
      navigator.serviceWorker.getRegistration().then(regInfo => {
        if (regInfo) {
          regInfo.update();
        } else {
          // eslint-disable-next-line
          navigator.serviceWorker.register('/pushwoosh-service-worker.js');
        }
      });
    }
  } catch (error) {
    console.warn("Couldn't receive site config", error);
  }
}
